module.exports = __webpack_public_path__ + "img/souvenir10.528d14c7.svg";